import auth0 from 'auth0-js';
import {NavigationGuard} from 'vue-router';
const CLIENT_ID = process.env.VUE_APP_AUTH0_CLIENT_ID;
const CLIENT_DOMAIN = process.env.VUE_APP_AUTH0_DOMAIN;
const REDIRECT = process.env.VUE_APP_AUTH0_CALLBACK_URL;
const SCOPE = 'openid';
import {isLoggedIn} from './auth-shared';

const auth = new auth0.WebAuth({
  clientID: CLIENT_ID || '',
  domain: CLIENT_DOMAIN || '',
});

export function login() {
  auth.authorize({
    responseType: 'token id_token',
    redirectUri: REDIRECT,
    scope: SCOPE,
  });
}

export const requireAuth: NavigationGuard = (to, from, next) => {
  if (!isLoggedIn()) {
    next({
      path: '/',
      query: {redirect: to.fullPath},
    });
  } else {
    next();
  }
};

export * from './auth-shared';
